<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import { cloneDeep, groupBy } from "lodash";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import VerificationCode from '@/components/modals/verification-code.vue';
import SubmittedData from './api-list-targets.vue';

const greaterFive = (value) => value.replace(/,/g, "") <= 5;
const lesserOne = (value) => value.replace(/,/g, "") >= 1;
export default {
    page: {
        title: "List of API",
    },
    components: {
        Layout,
        PageHeader,
        DatePicker,
        MaskedInput,
        VerificationCode,
        SubmittedData
    },
    data() {
        return {
            title: "Submitted API",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Submitted API",
                    active: true,
                },
            ],
            tableData: [],
            approvedData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            currentPageApp: 1,
            perPage: 10,
            perPageApp: 10,
            pageOptions: [10, 25, 50, 100],
            filterPosted: "",
            filterApproved: "",
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
            }),
            indexSelected: -1,
            tableBusy: false,
            approvedBusy: false,
            returnForm: {
                id: "",
                remarks: "",
            },
            form: {
                id: 0,
                name: "",
                description: "",
                isCatchUp: false,
                apiTypeId: "",
                targetId: this.$route.params.id,
                scoreEfficiency: "",
                scoreQuality: "",
                scoreTimeliness: "",
                finalRemarks: "",
                catchUpPlans: "",
                isCompleted: false,
                dateCompleted: "",
            },
            apiType: "",
            statusType: "posted",
            parentIndex: -1,
            selectedApi: {},
            selectedApiIds: [],
            selectedDU: null,
        };
    },
    validations: {
        returnForm: { remarks: { required } },
        form: {
            name: { required },
            description: { required },
            apiTypeId: { required },
            scoreEfficiency: { required, greaterFive, lesserOne },
            scoreQuality: { required, greaterFive, lesserOne },
            scoreTimeliness: { required, greaterFive, lesserOne },
            finalRemarks: { required },
        },
    },
    created() {
        this.totalRows = this.items.length;
        this.changeCycle(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    },
    methods: {
        changeCycle(cycle, campusId) {
            this.getPosted(cycle, campusId);
            this.getApproved(cycle, campusId);
        },
        updateItem(props, type, yId) {
            this.statusType = type;
            this.form = cloneDeep(props.item);
            this.form.dateCompleted = new Date(props.item.dateCompleted);
            this.apiType = props.item.apiType.type;
            this.form.scoreEfficiency = `${props.item.scoreEfficiency}`;
            this.form.scoreQuality = `${props.item.scoreQuality}`;
            this.form.scoreTimeliness = `${props.item.scoreTimeliness}`;
            if(type == "posted"){
                this.parentIndex = this.tableData.findIndex(x => x.id == yId);
                this.indexSelected = this.tableData[this.parentIndex].data.findIndex(x => x.id == props.item.id)
            }else{
                this.parentIndex = this.approvedData.findIndex(x => x.id == yId);
                this.indexSelected = this.approvedData[this.parentIndex].data.findIndex(x => x.id == props.item.id)
            }
            this.modalTitle = "Update API";
            this.$bvModal.show("modal-standard");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            } else {
                var data = cloneDeep(this.form);
                data.dateCompleted = data.isCompleted
                    ? this.getDate(this.form.dateCompleted)
                    : this.getDate(new Date());
                if (this.form.id > 0) {
                    this.$store
                        .dispatch("api/UpdateApi", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            if (this.statusType === "posted") {
                                this.tableData[this.parentIndex].data.splice(
                                    this.indexSelected,
                                    1,
                                    data
                                );
                            } else {
                                this.approvedData[this.parentIndex].data.splice(
                                    this.indexSelected,
                                    1,
                                    data
                                );
                            }
                            this.$bvModal.hide("modal-standard");
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                } else {
                    this.$store
                        .dispatch("api/CreateApi", data)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "warning"
                                );
                            }
                            if (this.statusType === "posted") {
                                this.tableData[this.parentIndex].data.push(res.data);
                            } else {
                                this.tableData[this.parentIndex].data.push(res.data);
                            }
                            this.$bvModal.hide("modal-standard");
                            this.showToast("Successfully created!", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
                this.submitted = false;
            }
        },
        getPosted(event, campusId) {
            this.tableBusy = true;
            this.$store
                .dispatch("planningapi/PendingPlanning", {cycle: event, campusId: campusId})
                .then((res) => {
                    this.tableBusy = false;
                    res.data.forEach((item) => {
                        item.totalAmt = this.formatCurrency(item.total);
                        item.rotateChevy = false;
                        item.showDetails = false;
                        item.deliveryUnit = item.planningTarget.deliveryUnit.name;
                        item.searchKey = ''
                        item.apiResources = [];
                        item.loadingResources = false;
                        item.toggleSelected = false;
                        item.selectAllApis = false;
                    });
                    var group = groupBy(res.data, "deliveryUnit");
                    var grouped = [];
                    var id = 1;
                    for (const key in group) {
                        let searchKey = '';
                        group[key].forEach((x) => {
                            searchKey += `${x.deliveryUnit}`;
                        })
                        grouped.push({
                            id: id++,
                            name: key,
                            data: group[key],
                            showData: false,
                            filterItem: searchKey
                        });
                    }
                    this.tableData = grouped;
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        getApproved(event, campusId) {
            this.approvedBusy = true;
            this.$store
                .dispatch("planningapi/ApprovedPlanning", {cycle: event, campusId})
                .then((res) => {
                    this.approvedBusy = false;
                    res.data.forEach((item) => {
                        item.totalAmt = this.formatCurrency(item.total);
                        item.rotateChevy = false;
                        item.showDetails = false;
                        item.backLoading = false;
                        item.deliveryUnit = item.planningTarget.deliveryUnit.name;
                        item.searchKey = '';
                        item.loadingResources = false;
                        item.toggleSelected = false;
                        item.selectAllApis = false;
                    });
                    var group = groupBy(res.data, "deliveryUnit");
                    var grouped = [];
                    var id = 1;
                    for (const key in group) {
                        let searchKey = '';
                        group[key].forEach((x) => {
                            searchKey += `${x.deliveryUnit}`;
                        })
                        grouped.push({
                            id: id++,
                            name: key,
                            data: group[key],
                            showData: false,
                            filterItem: searchKey
                        });
                    }
                    this.approvedData = grouped;
                })
                .catch((err) => {
                    this.approvedBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        returnAPI(data) {
            this.selectedDU = data.deliveryUnit;
            this.selectedApiIds = [data.id];
            this.returnForm.id = data.id;
            this.returnForm.remarks = "";
            this.$bvModal.show("return-modal");
        },
        verifyNow(code) {
            this.$store
                .dispatch("verification/verifyCode", {
                    code: code,
                    type: 'Multiple API Approval',
                    referenceId: this.selectedApiIds[0]
                })
                .then(async (res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let err = 0;
                    for await (const api of this.selectedApiIds) {
                        await this.$store
                            .dispatch("planningapi/ApprovePlanning", api)
                            .then((res) => {
                                if (res.data.error) {
                                    return this.showToast(
                                        res.data.errorMessage,
                                        "warning"
                                    );
                                }
                                let parentOrigIndex = this.tableData.findIndex(x => x.name === this.selectedDU.name);
                                let childIndex = this.tableData[parentOrigIndex].data.findIndex(x => x.id == api);
                                let childData = this.tableData[parentOrigIndex].data[childIndex];
                                let parentIndex = this.approvedData.findIndex(x => x.name === this.selectedDU.name);
                                if(parentIndex < 0){
                                    let data = {
                                        id: this.approvedData.length + 1,
                                        name: this.selectedDU.name,
                                        data: [childData],
                                        showData: false,
                                        filterItem: `${this.selectedDU.name}`
                                    }
                                    this.approvedData.push(data);
                                }else{
                                    this.approvedData[parentIndex].data.push(childData);
                                }
                                this.tableData[parentOrigIndex].data.splice(childIndex, 1);
                                this.initializeTableData(parentOrigIndex);
                            })
                            .catch((err) => {
                                err++;
                            });
                    }
                    if(err == 0){
                        this.$refs.postedData.selectedDU = null;
                        this.$refs.postedData.selectedTargets = []
                        this.showToast("Successfully approved!", "success");
                        this.$bvModal.hide('verify-modal')
                    }else{
                        this.showToast("Something went wrong!", "error");
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        approveAPI(data) {
            this.selectedApiIds = data.ids;
            this.selectedDU = data.deliveryUnit;
            Swal.fire({
                title: "Are you sure?",
                text: "You want to approve this API?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("verification/sendCode", {type: 'Multiple API Approval', id: data.ids[0]})
                        .then(async (res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.$bvModal.show('verify-modal')
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        initializeTableData(parentIndex) {
            if(this.tableData[parentIndex].data.length == 0){
                this.tableData.splice(parentIndex, 1);
            }
        },
        async returnAPISubmit() {
            this.submitted = true;
            this.$v.returnForm.$touch();
            if (this.$v.returnForm.$invalid) {
                return;
            }
            for await (const api of this.selectedApiIds) {
                await this.$store
                    .dispatch("planningapi/ReturnApi", this.returnForm)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "warning");
                        }
                        let parentOrigIndex = this.tableData.findIndex(x => x.name === this.selectedDU.name);
                        let childIndex = this.tableData[parentOrigIndex].data.findIndex(x => x.id == api);
                        this.tableData[parentOrigIndex].data.splice(childIndex, 1);
                        this.$refs.postedData.selectedDU = null;
                        this.$refs.postedData.selectedTargets = []
                        this.initializeTableData(parentOrigIndex);
                        this.showToast("Successfully returned", "success");
                        this.$bvModal.hide("return-modal");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle($event, $store.state.data.selectedCampus.id)" @changeCampus="changeCycle($store.state.data.cycle, $event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="modal-standard"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="apiForm"
            >
                <label for="scoreEfficiency" class="mb-0">Score </label>
                <b-row class="mb-3">
                    <b-col>
                        <small>Efficiency</small>
                        <masked-input
                            autocomplete="off"
                            id="scoreEfficiency"
                            type="text"
                            v-model="form.scoreEfficiency"
                            placeholder="Enter Efficiency..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted && $v.form.scoreEfficiency.$error,
                            }"
                            :mask="currencyMask"
                        ></masked-input>
                        <div
                            v-if="submitted && $v.form.scoreEfficiency.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.scoreEfficiency.required"
                                >This value is required.</span
                            >
                            <span v-if="!$v.form.scoreEfficiency.greaterFive"
                                >This value should not be greater than 5.</span
                            >
                            <span v-if="!$v.form.scoreEfficiency.lesserOne"
                                >This value should not be lesser than 1.</span
                            >
                        </div>
                    </b-col>
                    <b-col>
                        <small>Quality</small>
                        <masked-input
                            autocomplete="off"
                            id="scoreQuality"
                            type="text"
                            v-model="form.scoreQuality"
                            placeholder="Enter Quality..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted && $v.form.scoreQuality.$error,
                            }"
                            :mask="currencyMask"
                        ></masked-input>
                        <div
                            v-if="submitted && $v.form.scoreQuality.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.scoreQuality.required"
                                >This value is required.</span
                            >
                            <span v-if="!$v.form.scoreQuality.greaterFive"
                                >Maximum is 5.</span
                            >
                            <span v-if="!$v.form.scoreQuality.lesserOne"
                                >Minimum is 1.</span
                            >
                        </div>
                    </b-col>
                    <b-col>
                        <small>Timeliness</small>
                        <masked-input
                            autocomplete="off"
                            id="scoreTimeliness"
                            type="text"
                            v-model="form.scoreTimeliness"
                            placeholder="Enter Timelines..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted && $v.form.scoreTimeliness.$error,
                            }"
                            :mask="currencyMask"
                        ></masked-input>
                        <div
                            v-if="submitted && $v.form.scoreTimeliness.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.scoreTimeliness.required"
                                >This value is required.</span
                            >
                            <span v-if="!$v.form.scoreTimeliness.greaterFive"
                                >This value should not be greater than 5.</span
                            >
                            <span v-if="!$v.form.scoreTimeliness.lesserOne"
                                >This value should not be lesser than 1.</span
                            >
                        </div>
                    </b-col>
                </b-row>
                <div class="mb-3">
                    <label for="finalRemarks">Final Remarks </label>
                    <textarea
                        id="finalRemarks"
                        rows="3"
                        v-model="form.finalRemarks"
                        placeholder="Enter Final Remarks..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && $v.form.finalRemarks.$error,
                        }"
                    ></textarea>
                    <div
                        v-if="submitted && $v.form.finalRemarks.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.finalRemarks.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <input
                        autocomplete="off"
                        class="form-check-input"
                        type="checkbox"
                        id="isCompleted"
                        v-model="form.isCompleted"
                    />&nbsp;&nbsp;
                    <label class="form-check-label" for="isCompleted"
                        >Is Completed?</label
                    >
                </div>
                <div class="mb-3" v-if="form.isCompleted">
                    <label for="dateCompleted">Date Completed </label>
                    <date-picker
                        v-model="form.dateCompleted"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Date Completed..."
                    ></date-picker>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('modal-standard')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="return-modal"
            title="Return Remarks"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form @submit.prevent="returnAPISubmit" class="needs-validation">
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label for="description">Remarks </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="returnForm.remarks"
                                placeholder="Enter Remarks..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                        $v.returnForm.remarks.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.returnForm.remarks.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.returnForm.remarks.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Return API
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('return-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-tabs content-class="pt-3 pb-3 text-muted">
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Posted</span>
                </template>
                <SubmittedData 
                    :busy="tableBusy"
                    :data="tableData"
                    title="List of Posted APIs by Delivery Unit"
                    :forApproval="true"
                    @approve-apis="approveAPI"
                    @return-api="returnAPI"
                    ref="postedData"
                />
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Approved</span>
                </template>
                <SubmittedData 
                    :busy="approvedBusy"
                    :data="approvedData"
                    title="List of Approved APIs by Delivery Unit"
                />
            </b-tab>
        </b-tabs>
        <VerificationCode @dropCode="verifyNow" ref="verification" />
    </Layout>
</template>